import React from 'react';
import {
  FiArrowUpCircle,
  FiArrowDownCircle,
  FiRepeat,
  FiShield,
  FiDollarSign,
  FiRefreshCw,
  FiGift,
  FiAlertCircle,
  FiSettings,
} from 'react-icons/fi';
import { TransactionType } from '@/types/wallet';

interface TransactionTypeIconProps {
  type: TransactionType;
  size?: number;
  className?: string;
}

const TransactionTypeIcon: React.FC<TransactionTypeIconProps> = ({ type, size = 20, className = '' }) => {
  const iconProps = { size, className };

  switch (type) {
    case 'deposit':
      return <FiArrowDownCircle {...iconProps} className={`text-green-600 ${className}`} />;
    case 'withdrawal':
      return <FiArrowUpCircle {...iconProps} className={`text-red-600 ${className}`} />;
    case 'transfer_in':
      return <FiRepeat {...iconProps} className={`text-blue-600 ${className}`} />;
    case 'transfer_out':
      return <FiRepeat {...iconProps} className={`text-orange-600 ${className}`} />;
    case 'escrow_release':
      return <FiShield {...iconProps} className={`text-green-600 ${className}`} />;
    case 'escrow_hold':
      return <FiShield {...iconProps} className={`text-yellow-600 ${className}`} />;
    case 'escrow_refund':
      return <FiRefreshCw {...iconProps} className={`text-purple-600 ${className}`} />;
    case 'commission_deduction':
      return <FiDollarSign {...iconProps} className={`text-gray-600 ${className}`} />;
    case 'refund':
      return <FiRefreshCw {...iconProps} className={`text-green-600 ${className}`} />;
    case 'bonus':
      return <FiGift {...iconProps} className={`text-emerald-600 ${className}`} />;
    case 'penalty':
      return <FiAlertCircle {...iconProps} className={`text-red-600 ${className}`} />;
    case 'adjustment':
      return <FiSettings {...iconProps} className={`text-gray-600 ${className}`} />;
    default:
      return <FiDollarSign {...iconProps} className={className} />;
  }
};

export default TransactionTypeIcon;
